import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import styled from 'styled-components';

import LadyBug from './Ladybug.svg';

import {About} from './about'
import {Oferta} from './ofera'
import {Kontakt} from './kontakt'

const MainAppDiv = styled.div`
  display: flex;
  flex-direction: row;
  position: fixed;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #111;
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  height: 100%;
  background: #fefefe;
  border-radius: 25px;
`;

const NavBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 5rem;
  background: #666974;
  border-radius: 20px 20px 0 0;
`;

const LogoHolder = styled.div`
  display: flex;
  color: #fefefe;
  align-items: center;
  text-align: center;
  user-select: none;
`;

const Logo = styled.img`
  width: 4.5rem;
`;

const RouteDiv = styled.div`
  display: flex;
  width: 20%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  text-align: center;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #fefefe;
  &:visited{
    color: #fefefe;
  }
`

export const App = () => {
  return (
    <MainAppDiv>
      <Router>
        <MainWrapper>
          <NavBar>
            <LogoHolder>
              <Logo src={LadyBug} alt="Ladybug"></Logo>
              <StyledLink to="/">Klub Dziecięcy Biedroneczki</StyledLink>
            </LogoHolder>
            <RouteDiv>
              <StyledLink to="/oferta">Oferta</StyledLink>
              <StyledLink to="/kontakt">Kontakt</StyledLink>
            </RouteDiv>
          </NavBar>
          <div style={{flex: '1', height: '100%'}}>
            <Switch>
              <Route exact path="/" component={About}></Route>
              <Route exact path="/oferta" component={Oferta}></Route>
              <Route exact path="/kontakt" component={Kontakt} ></Route>
            </Switch>
          </div>
        </MainWrapper>
      </Router>
    </MainAppDiv>
  );
};
